import EpgActions from "./Epg/ActionButtons";
import LiveActions from "./Live/Actions"
import { useLocation } from 'react-router-dom';

const Options = () => {
    const location = useLocation();

  return (
    <>
      {location.pathname.includes("epg") && <EpgActions />}
      {location.pathname.includes("live") && !location.pathname.includes("epg") && <LiveActions/>}
    </>
  );
};

export default Options;